import {AnimationValueMap, IAnimationRef} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';
import {VisualBox} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/VisualBox';
import {Prop} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/Prop';
import {Repeater} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/Repeater';
import {GetPropPathFunc, GetPropStylerFunc} from '@mintdata/mint-kit/api/animation/AnimationProps';
import {PropPath} from '@mintdata/mint-kit/api/properties/PropPath';
import {Easing} from '@popmotion/easing';
import {Styler} from 'stylefire';

export interface IAnimateTarget
{
    visualBox:VisualBox;
    repeater:Repeater;
}

export enum PlaybackType
{
    Flip = 'flip',
    Loop = 'loop',
    Yoyo = 'yoyo'
}

export enum AnimateTransformProperty
{
    Left = 'left',
    Top = 'top',
    Right = 'right',
    Bottom = 'bottom',
    Width = 'width',
    Height = 'height',
    RotateX = 'rotateX',
    RotateY = 'rotateY',
    RotateZ = 'rotateZ',
    Scale = 'scale',
    ScaleX = 'scaleX',
    ScaleY = 'scaleY',
    ScaleZ = 'scaleZ',
    Opacity = 'opacity',
    SkewX = 'skewX',
    SkewY = 'skewY',
    TranslateX = 'translateX',
    TranslateY = 'translateY',
    TranslateZ = 'translateZ',
    X = 'x',
    Y = 'y'
}

export interface IPropData
{
    prop:Prop<any>;
    propPath:PropPath;
}

export enum AnimateUnitsType
{
    None,
    Number,
    Pixels,
    Percentages,
    Fractions
}

export type IAnimateProps = {
    from?:AnimationValueMap;
    to?:AnimationValueMap;
    duration?:number;
    ease?:Easing | Easing[] | {[key:string]:Easing};
    elapsed?:number;
    playDirection?:number;
    flip?:number;
    loop?:number;
    yoyo?:number;
    repeatDelay?:number;
};

export interface IAnimateOptions
{
    readonly props:IAnimateProps;
    isAbsoluteValues:boolean;
    isPropsSeeInitialValues:boolean;
    isKeepFinalValues:boolean;
    isDisabled:boolean;
    delay:number;
    invalidProp:string;
    isToFinal:boolean;
}

export interface IAnimationData
{
    isInProgress?:boolean;
    transformRef?:HTMLElement;
    transform?:Styler;
    getPropStyler?:GetPropStylerFunc;
    getPropPath?:GetPropPathFunc;
    initialValues?:AnimationValueMap;
    animationRefs:Array<IAnimationRef>;
    units:{[property:string]:AnimateUnitsType},
}

export type PropertyPathFunc = (animationTarget:IAnimateTarget) => string;
export type PropertySetterFunc = (animateTarget:IAnimateTarget,
                                  animationData:IAnimationData,
                                  styler:Styler,
                                  property:string,
                                  cssProperty:string,
                                  value:any) => void;

export interface IAnimationPropertyData
{
    readonly defaultFromValue?:any;
    readonly propertyPath?:string | PropertyPathFunc;
    readonly cssProperty?:string;
    readonly setter?:PropertySetterFunc;
    readonly relatedPropsUpdater?:(animationData:IAnimationData, propData:IPropData, value:any) => void;
}
